export default __webpack_public_path__ + "static/SuisseIntlMedium-6a3a35b5c0bc7d99642c0d077c326e92.woff2";